import { Activity, Bell, BookOpen, Building2, Database, FileSpreadsheet, GraduationCap, LayoutDashboard, LayoutGrid, ListChecks, Plug, Settings, Users, type LucideIcon } from 'lucide-react'

// The left menu as the owner approved it in the simulation (2026-10-17); C-1 (2026-10-18): Dashboard instead of the screen
// map, the developer docs (/docs), the "Later" group gone.
export interface MenuItem {
  to: string
  label: string
  Icon: LucideIcon
  permission?: string
  /** opens in a new browser tab (the docs: the Hub stays where it was) */
  newTab?: boolean
  end?: boolean
}
export interface MenuSection {
  label: string
  items: MenuItem[]
}

export const MENU: MenuSection[] = [
  {
    label: 'Lenders',
    items: [
      { to: '/', label: 'Dashboard', Icon: LayoutDashboard, end: true },
      { to: '/lenders', label: 'Lenders', Icon: Building2, permission: 'lenders.view' },
      { to: '/lenders/new', label: 'Add a lender', Icon: LayoutGrid, permission: 'lenders.edit' },
      { to: '/endpoints', label: 'Active endpoints', Icon: Activity, permission: 'gateway.view' },
      { to: '/runs', label: 'Workflow runs', Icon: ListChecks, permission: 'gateway.view' },
      { to: '/alerts', label: 'Alerts', Icon: Bell, permission: 'alerts.view' },
      { to: '/mis', label: 'Lender MIS', Icon: FileSpreadsheet, permission: 'mis.upload' },
    ],
  },
  {
    label: 'Code & storage',
    items: [
      { to: '/catalogue', label: 'API catalogue', Icon: BookOpen, permission: 'lenders.view' },
      { to: '/storage', label: 'Code storage', Icon: Database, permission: 'gateway.view' },
      { to: '/hub-api', label: 'Hub API & consumers', Icon: Plug, permission: 'lenders.view' },
      { to: '/docs', label: 'Developer docs', Icon: GraduationCap, newTab: true },
    ],
  },
  {
    label: 'Admin',
    items: [
      { to: '/users', label: 'Users & roles', Icon: Users, permission: 'users.manage' },
      { to: '/settings', label: 'Settings', Icon: Settings, permission: 'settings.manage' },
    ],
  },
]

export function titleFor(pathname: string): string {
  if (pathname.startsWith('/lenders/new')) return 'Add a lender'
  if (pathname === '/profile') return 'My profile'
  if (pathname.startsWith('/lenders/')) return 'Lenders'
  const all = MENU.flatMap((s) => s.items)
  const hit = all.find((i) => (i.end ? pathname === i.to : pathname === i.to || pathname.startsWith(i.to + '/')))
  return hit?.label ?? 'Lender Hub'
}
